// extracted by mini-css-extract-plugin
export default {"comment":"Comment_comment__Og9aN","right":"Comment_right__Yu7tJ"};